import React from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Draggable from 'react-draggable'
import { Dialog, Paper, DialogContent, Slide } from '@material-ui/core'
import { ThemeProvider, withStyles } from '@material-ui/core/styles'

import materialTheme from 'theme/materialTheme'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide {...props} direction='up' ref={ref} timeout={500} />
})

class DraggableDialog extends React.Component {
  constructor (props) {
    super(props)
    this.state = { }

    // React dragable
    this.deltaY = 0
    this.changesY = 200
  }

  handleDrag = (e, ui) => {
    this.deltaY += ui.deltaY

    // If pull down more than this number, close the picker dialog.
    if (this.deltaY > this.changesY) {
      this.props.onClose()
    }
  }

  resetDeltaY = () => {
    this.deltaY = 0
  }

  renderPaperComponent = (props) => {
    return (
      <Draggable
        axis='y'
        bounds={{ top: 0 }}
        cancel={'[class*="MuiDialogContent-root"]'}
        position={{ x: 0, y: 0 }}
        onDrag={this.handleDrag}
        onStop={this.resetDeltaY}
      >
        <Paper {...props} />
      </Draggable>
    )
  }

  render () {
    const { classes, open, onClose, children } = this.props

    return (
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        TransitionComponent={Transition}
        PaperComponent={this.renderPaperComponent}
        classes={{
          root: classes.root,
          paper: classes.paperRoot,
          paperFullWidth: classes.paperFullWidth,
        }}
      >
        <ThemeProvider theme={materialTheme}>
          <div className={classes.draggableIndicator} />
          <DialogContent>
            {children}
          </DialogContent>
        </ThemeProvider>
      </Dialog>
    )
  }
}

const styles = {
  root: {
    zIndex: '900 !important',
  },
  paperFullWidth: {
    width: '100%',
    minWidth: '100%',
    maxHeight: '100%',
  },
  paperRoot: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    margin: 0,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    height: 'calc(100% - 16px)',
    // '-ms-overflow-style': 'none', // IE and Edge
    // 'scrollbar-width': 'none', // Firefox
    // '&::-webkit-scrollbar': {
    //   display: 'none', // Hide scrollbar for Chrome, Safari and Opera
    // },
  },
  draggableIndicator: {
    width: 96,
    border: '2px solid #CBCBCB',
    borderRadius: 800,
    margin: '16px auto 16px auto',
  },
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => ({
})

export default withRouter(
  compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
    injectIntl,
  )(DraggableDialog),
)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/Dialog/DraggableDialog.jsx